/**
 * Generation Config
 *
 * Unified configuration system for generation workflows.
 */

// Export configs and lookups
export {
  workflowConfigs,
  workflowConfigsArray,
  workflowConfigByKey,
  workflowOptions,
  workflowOptionById,
} from './workflows';

// Export workflow helpers
export {
  isWorkflowAvailable,
  isEnhancementWorkflow,
  shouldReturnAfterSubmit,
  shouldShowBackButton,
  isWorkflowOrVariant,
  getWorkflowsForEcosystem,
  getWorkflowsWithCompatibility,
  getAllWorkflowsGrouped,
  getDefaultEcosystemForWorkflow,
  getEcosystemsForWorkflow,
  getInputTypeForWorkflow,
  getOutputTypeForWorkflow,
  getWorkflowModes,
  workflowGroups,
} from './workflows';

// Export types
export type { WorkflowConfig, WorkflowConfigs, WorkflowCategory, WorkflowGroup } from './types';

export type { WorkflowOption } from './workflows';

// Export sampler/scheduler compatibility
export {
  CompatibilityRating,
  SAMPLER,
  SCHEDULER,
  samplers,
  schedulers,
  samplerById,
  samplerByKey,
  schedulerById,
  schedulerByKey,
  getEcosystemCompatibility,
  getCompatibilityRating,
} from './sampler-scheduler-compatibility';
export type {
  SamplerRecord,
  SchedulerRecord,
  SamplerSchedulerCompatibility,
} from './sampler-scheduler-compatibility';
